var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-field"},[_c('div',{staticClass:"wrap"},_vm._l((_vm.fields),function(field){return _c(_vm.fieldComp,_vm._b({key:field.title,tag:"component"},'component',[field, {sectionId: _vm.sectionId}],false))}))])}
var staticRenderFns = []

export { render, staticRenderFns }